import Lookup from 'src/componentes/select-async';
import CondicionanteEdit from 'src/paginas/remuneracao-variavel/condicionante/edit';
import DesdobramentoList from 'src/paginas/remuneracao-variavel/condicionante';

const CondicionanteLookup = (props) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/CondicionanteLookup"
      clearable={true}
      showSearch
      editComponent={CondicionanteEdit}
      searchComponent={DesdobramentoList}
      {...props}
    />
  );
};

export default CondicionanteLookup;
